module.exports = __webpack_public_path__ + "img/prior-year.f30a2810.svg";